import style from "./mainPartnership.module.scss";
import {Trans, useTranslation} from "react-i18next";
import {useLanguage} from "../../../hooks/hooks";

export function PartnerTitleField() {
    const { t } = useTranslation("brand");
    const { isKorean} = useLanguage();
    return (
        <div className={style.contextArea}>
            <div className={`${style.textArea} ${isKorean ? "" : style.en}`}>
                <div className={style.textWrapper}>
                    <Trans t={t} i18nKey="partner.desc"
                           components={{
                               p: <p/>,
                               bold:<p className={style.bold} />,
                               blue: <span className={style.blue} />
                           }}
                    />
                </div>
                <div className={style.textWrapper}/>
            </div>
            <div className={style.partnershipImage}/>
        </div>
    )
}